<template>
  <div class="items-wrap d-flex flex-wrap" :class="{ base: isBase }">
    <div></div>
    <v-card
      class="mx-auto my-12"
      max-width="374"
      v-for="(item, key) in items"
      :key="key"
      :link="false"
    >
      <div
        @click="cardClick(item)"
        class="card-overlay"
        v-if="hasClickAction"
      ></div>
      <div
        :style="'background:' + getCardBg(item.id)"
        class="bg-card d-flex justify-space-between flex-column pa-5"
      >
        # {{ item.id }}
        <span v-if="item.alias" class="font-weight-bold font-italic">
          {{ item.alias }}</span
        >
        <div class="d-flex justify-space-between">
          <div class="subtitle-1 mt-0">
            {{ item["created_at"] | formatDate }}
          </div>
          <div class="block-link" v-if="showBlocksLink">
            <router-link :to="{ path: getLinkPath(item.id) }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    :color="isBase ? 'white' : 'primary'"
                    dark
                    large
                    v-bind="attrs"
                    v-on="on"
                    >mdi-clipboard-text</v-icon
                  >
                </template>
                <span>{{ getLinkName() }}</span>
              </v-tooltip>
            </router-link>
          </div>
        </div>
      </div>
      <v-card-title>{{ item.name }}</v-card-title>
      <v-card-text style="min-height: 82px;">
        <div class="my-4 subtitle-1" v-if="item.url">
          <a target="_blank" :href="item.url">{{ item.url }}</a>
        </div>
        <div>{{ item.description }}</div>
      </v-card-text>
      <v-divider v-if="!hideActions" class="mx-4"></v-divider>
      <v-card-actions v-if="!hideActions">
        <v-btn color="blue lighten-2" text @click="editItem(item)">
          Редактировать
        </v-btn>
        <v-btn color="red lighten-2" text @click="deleteItem(item)">
          Удалить
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { GLOBAL } from "@/config/consts";

export default {
  name: "CardItem",
  props: {
    hideActions: Boolean,
    showBlocksLink: Boolean,
    hasClickAction: Boolean,
    items: {
      type: Array,
      required: true
    },
    landingId: String,
    type: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      baseLandingId: GLOBAL.baseLandingId
    };
  },
  methods: {
    getCardBg(id) {
      if (this.isBase) {
        return GLOBAL.baseColor;
      }
      return this.stringToColor(this.landingId ? this.landingId : id);
    },
    editItem(item) {
      this.$emit("editItem", item);
    },
    cardClick(item) {
      this.$emit("cardClick", item);
    },
    deleteItem(item) {
      this.$emit("deleteItem", item);
    },
    getLinkPath(id) {
      if (this.type === "landings") {
        return `/blocks?landing_id=${id}`;
      } else {
        return `/fields?landing_id=${this.landingId}&block_id=${id}`;
      }
    },
    getLinkName() {
      return this.type === "landings" ? "Список блоков" : "Список полей";
    },
    stringToColor(str) {
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      return `hsl(${hash % 360}, 100%, 85%)`;
    }
  },
  computed: {
    isBase() {
      return this.landingId === this.baseLandingId;
    }
  }
};
</script>

<style lang="scss" scoped>
.v-sheet.v-card {
  position: relative;
  .card-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
    cursor: pointer;

    &:hover {
      background: rgba(0, 0, 0, 0.1);
    }
  }
}
.bg-card {
  height: 200px;
  position: relative;
}
</style>
